exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-wrapper >>> .slick-header-column {\r\n    height: 30px;\r\n    max-height: 30px;\r\n    padding-top: 6px;\r\n    -ms-flex-wrap: nowrap;\r\n        flex-wrap: nowrap;\r\n}\r\n\r\n.grid-wrapper >>> .slick-header-column button:focus {\r\n    outline: none;\r\n}\r\n\r\n.grid-wrapper >>> .slick-column-name {\r\n    width: auto;\r\n    /*align-self: center;*/\r\n    max-height: 28px;\r\n    line-height: 1;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/buffer-graph/styles/tabs-styles.css
// module id = ./src/app/buffer-graph/styles/tabs-styles.css
// module chunks = main